import { Inbox, InboxContent } from "@novu/react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useCurrentUser } from "../data/auth/hooks";

export const Route = createFileRoute("/notifications")({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = useNavigate();
  const { data: currentUserData } = useCurrentUser();

  if (!currentUserData) {
    return null;
  }

  return (
    <div className="w-full h-full">
      <Inbox
        applicationIdentifier={
          process.env.NODE_ENV === "development"
            ? "bt9yrvaEDBk9"
            : "TvtmTMqKVoUD"
        }
        subscriberHash={currentUserData.novuSubHashedId}
        subscriber={{
          subscriberId: currentUserData.id,
          firstName: currentUserData.firstName,
          lastName: currentUserData.lastName,
          email: currentUserData.email,
        }}
        routerPush={(path: string) => {
          navigate({ to: path });
        }}
        appearance={{
          variables: {
            colorPrimary: "#DD2450",
            colorForeground: "#0E121B",
            fontSize: "18px",
          },
        }}
      >
        <div className="w-full h-full overflow-hidden">
          <InboxContent />
        </div>
      </Inbox>
    </div>
  );
}
